module.exports = __webpack_public_path__ + "img/login_bottom1.6892b30e.png";